module.exports = __webpack_public_path__ + "static/media/profile.3eed5894.png";